import { configureStore } from '@reduxjs/toolkit'

import advertisementReducer from './Slices/advertisementSlice';
import campaignReducer from './Slices/campaignSlice';
import clientReportsReducer from './Slices/clientReportsSlice';
import dashboardReducer from './Slices/dashboardSlice';
import deviceTypeReducer from './Slices/deviceTypeSlice';
import errorHandlingReducer from './Slices/errorHandlingSlice';
import popUpReducer from './Slices/popUpSlice';
import progressReducer from './Slices/progressSlice';
import registerReducer from './Slices/registerSlice';
import templateReducer from './Slices/templateSlice';

const store = configureStore({
    reducer: {
        advertisement : advertisementReducer,
        campaign:campaignReducer,
        clientReports:clientReportsReducer,
        dashboard:dashboardReducer,
        deviceType:deviceTypeReducer,
        errorHandling:errorHandlingReducer,
        popup:popUpReducer,
        progress:progressReducer,
        register:registerReducer,
        template:templateReducer
        

    },
});


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store;